import React from "react";

function AlertIcon() {
    return (
        <svg
            className="ek-chat__message--alert-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#1jovy9deda)" fill="#FF443A">
                <path
                    opacity=".3"
                    d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
                />
                <path d="M13 8a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V8zM13 17a1 1 0 1 0-2 0 1 1 0 0 0 2 0z" />
            </g>
            <defs>
                <clipPath id="1jovy9deda">
                    <path d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default AlertIcon;
